interface GroupFoldingRows<R> {
  isGroupHeader: (row: R) => boolean;
  idOf: (row: R) => string;
}

// Group headers always stay; the rows after a collapsed header, up to the next header, are dropped.
export function rowsVisibleAfterFolding<R>(
  rows: R[],
  { isGroupHeader, idOf }: GroupFoldingRows<R>,
  collapsedGroupIds: ReadonlySet<string>
): R[] {
  let isInCollapsedGroup = false;
  return rows.filter((row) => {
    if (isGroupHeader(row)) {
      isInCollapsedGroup = collapsedGroupIds.has(idOf(row));
      return true;
    }
    return !isInCollapsedGroup;
  });
}

export function toggledGroupIds(
  collapsedGroupIds: ReadonlySet<string>,
  groupId: string
): Set<string> {
  const next = new Set(collapsedGroupIds);
  if (!next.delete(groupId)) {
    next.add(groupId);
  }
  return next;
}
